import React from "react";
import { useParams, useNavigate } from "react-router";
import { Plus } from "lucide-react";
import { usePageConfig } from "../../contexts/PageConfigContext";
import { UsersList } from "./components/UsersList";
import { UserForm } from "./components/UserForm";

export const UsersPage: React.FC = () => {
  const { setPageConfig } = usePageConfig();
  const navigate = useNavigate();

  React.useEffect(() => {
    setPageConfig({
      title: "Usuarios",
      actions: [
        {
          label: "Nuevo Usuario",
          icon: Plus,
          onClick: () => navigate("/usuarios/nuevo"),
          variant: "primary" as const,
        },
      ],
    });
  }, [setPageConfig, navigate]);

  return (
    <div className="w-full">
      <UsersList onEdit={(id) => navigate(`/usuarios/editar/${id}`)} />
    </div>
  );
};

export const UserFormPage: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const navigate = useNavigate();
  const { setPageConfig } = usePageConfig();

  React.useEffect(() => {
    setPageConfig({
      title: id ? "Editar Usuario" : "Nuevo Usuario",
      actions: [],
    });
  }, [id, setPageConfig]);

  const handleFormClose = () => {
    navigate("/usuarios");
  };

  const handleFormSuccess = () => {
    navigate("/usuarios");
  };

  return (
    <div className="w-full">
      <div className="max-w-3xl mx-auto">
        <UserForm
          userId={id}
          onClose={handleFormClose}
          onSuccess={handleFormSuccess}
        />
      </div>
    </div>
  );
};
